import { Reveal } from "./motion";

export const Payments = () => (
  <section
    id="payments"
    data-testid="payments-section"
    className="relative z-10 bg-[#262626] py-24 sm:py-32 border-y border-white/5"
  >
    <div className="mx-auto max-w-3xl px-5 sm:px-8">
      <Reveal>
        <p className="text-xs tracking-[0.3em] uppercase text-[#FF4500] font-bold mb-4">
          Flexible Payment Options
        </p>
        <h2 className="font-display font-bold uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl">
          Paying should be simple
        </h2>
        <p className="mt-6 text-neutral-300 text-base sm:text-lg leading-relaxed">
          We believe paying for a move should be simple and convenient. Duke
          Summers Moving accepts multiple convenient payment methods.
        </p>
        <p
          data-testid="payment-confirm-note"
          className="mt-6 text-neutral-100 text-lg font-semibold border-l-2 border-[#FF4500] pl-4"
        >
          Payment options are confirmed with your quote.
        </p>
      </Reveal>
    </div>
  </section>
);
